<template>
  <div class="xslt-template w-full h-full" :class="{ haspdf: hasPdf}">
    <detail-layout-two-columns v-if="hasModuleCustomXslt" class="h-full">
      <template slot="LeftCol">
        <base-header style="padding-left: 0px" icon="user" :content="header" />
        <div class="form-wrapper w-full">
          <el-form :model="form" :rules="rules" ref="ruleForm">
            <div class="lg:mb-2">
              <el-form-item prop="basetemplate">
                <base-el-select ref="templates" class="w-full" :options="baseTemplates" v-model="form.basetemplate"
                  :option-value="optionValue" value-key="idPlantilla" :allow-create="false && role === 3"
                  :create-method="baseTemplateCreateMethod" :disabled="editTemplate" filterable
                  :prepend-disabled="!form.basetemplate" :append-disabled="!form.basetemplate" @input="onBaseTemplateInput"
                  @clear="onBaseTemplateClear" @prepend-click="applyChanges" @append-click="showHtml = !showHtml">
                  <template #prepend v-if="form.basetemplate && form.basetemplate.Owner && false">
                    <base-icon :name="!editTemplate ? 'editpencil' : 'save'" />
                  </template>
                  <template #append>
                    <base-icon :name="showHtml ? 'eye' : 'eyeslash'" />
                  </template>
                </base-el-select>
              </el-form-item>
            </div>
            <div class="lg:mb-2 flex">
              <div class="w-full">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('plantilla_pdf.registration_data_location') }}</label>
                <el-switch class="switch-text break-normal both-switch" 
                    v-model="form.textoIzq" 
                    :active-text="$t('plantilla_pdf.left_margin')" 
                    :inactive-text="$t('plantilla_pdf.page_footer')"
                    inactive-color="var(--primary-800)"
                    :disabled="!form.basetemplate" />
              </div>
              <div class="w-full">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('plantilla_pdf.languaje_for_foreings') }}</label>
                <el-switch class="switch-text break-normal both-switch" 
                    v-model="form.TraducirParaExtranjeros" 
                    :active-text="$t('langs.en')" 
                    :inactive-text="$t('langs.es')"
                    inactive-color="var(--primary-800)"
                    :disabled="!form.basetemplate" />
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="flex items-center">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('plantilla_pdf.logo_custom')}}</label>
                <base-tooltip-icon size="sm" :content="tooltipContentLogo" class="ml-2"/>
              </div>
              <div>
                <div class="flex -mx-2 flex-col lg:flex-row">
                  <div class="px-2 mb-2 lg:mb-0">
                    <el-form-item prop="fileLogo" ref="uploadlogo">
                      <Upload
                        ref="upload"
                        id="pfxselector"
                        class="bg-white dark:bg-darkblue-900"
                        :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                        drag
                        action="#"
                        accept="image/png"
                        :limit=1
                        :multiple="false"
                        :disabled="!form.basetemplate"
                        :auto-upload=false
                        :on-remove="handleRemoveLogo"
                        :on-change="handleChangeLogo">
                        <i class="el-icon-upload"></i>
                        <p v-if="fileLogo.name" class="el-upload__text"><em>{{fileLogo.name}}</em></p>
                        <div v-else class="el-upload__text" v-html="$tc('app.upload_default_no_file_text', 1)"></div>
                      </Upload>
                    </el-form-item>
                    <div class="">
                      <div v-if="fileLogo.b64" class="flex flex-col pb-10 ">
                        <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-2">{{$t('plantilla_pdf.logo_custom_previsualizacion')}}</label>
                        <div class="flex items-center gap-x-2">
                          <img 
                            id="logo-custom-client-light" 
                            ref="logo-custom-client-light" 
                            :src="`data:image/${getExtensionFromFile(fileLogo.name)};base64, ${fileLogo.b64}`" 
                            :alt="$t('plantilla_pdf.logo_custom')" 
                            class="w-[300px] h-[74px] border-2 border-solid border-primary-300 dark:bg-white rounded object-scale-down object-left"/>
                          <base-button-icon 
                            v-if="hasLogoSaved" 
                            name="cross" 
                            size="xs" 
                            iconSize="xs" 
                            mode="primary-phantom"
                            :disabled="!form.basetemplate"
                            @click="handleRemoveLogo"/>
                        </div>
                      </div>
                      <div v-else class="flex flex-col pb-10 ">
                        <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-2">{{$t('personalization.empty_logo_info_msg')}}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="lg:mb-2" v-if="editTemplate && false">
              <!-- TODO: Incluir text editor -->
            </div>
          </el-form>
        </div>
      </template>
      <template slot="RightCol">
        <div v-show="form.basetemplate && showHtml" :class="{ 'h-screen': hasPdf }"
          class="bg-primary-50 dark:bg-darkblue-800 dark:text-darkblue-200 xl:inline-block relative w-full flex-grow hideHScroll lg:h-full divide-y-2 divide-blue-200 dark:divide-gray-800">
          <PDFViewerApp v-show="hasPdf && !editTemplate" :search="actualFilterContent"
            @pdfViewerOpenHandler="pdfViewerOpenHandler" :pdf="pdfUrl" :name="pdfName" />
          <div v-if="!hasPdf || editTemplate" class="w-full h-full p-2">
            <div class="lg:mb-2 lg:mt-2 text-center">{{$t('plantilla_pdf.final_pdf_may_differ_advice')}}</div>
            <iframe id="container-xhtml-iframe" class="transformed-result"></iframe>
          </div>
        </div>
      </template>
      <template slot="layout-extend">
        <base-footer>
          <template slot="actions">
            <base-button-responsive mode="secondary" :text="isFromClient ? $t('app.cancel') : $t('app.back')" icon="cross"
              @click="goBack" :loading="isGeneralLoading" />
            <base-button-responsive mode="primary" :text="$t('app.save')" icon="check" @click="submitForm('ruleForm')"
              :loading="isGeneralLoading" :disabled="isGeneralLoading" />
          </template>
        </base-footer>
      </template>
    </detail-layout-two-columns>
    <detail-layout-full-width v-else class="h-full">
      <template slot="header">
        <base-header icon="user" :content="header" />
      </template>
      <template slot="main">
        <div class="dark:text-white">{{ $t('feedback.error.absent_module_error') }}</div>
      </template>
      <template slot="layout-extend">
        <base-footer>
          <template slot="actions">
          </template>
        </base-footer>
      </template>
    </detail-layout-full-width>
  </div>
</template>

<script>
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import DetailLayoutTwoColumns from '@/components/layout/DetailLayoutTwoColumns.vue'
import PDFViewerApp from '@/components/pdf/PDFViewerApp.vue'
import { Upload } from 'element-ui'

import { i18n } from '@/i18n'
import { getClient } from '@/services/clients/getClient'
import { genericGETFile } from '@/services/genericGETFile'
import { getPlantillasImagen } from '@/services/clients/getPlantillasImagen'
import { updatePlantillaXslt } from '@/services/clients/updatePlantillaXslt'

export default {
  name: 'xslt-template-detail',
  components: {
    DetailLayoutFullWidth,
    DetailLayoutTwoColumns,
    Upload,
    PDFViewerApp,
  },
  data () {
    return {
      isMounted: false,
      activeName: 'es',
      tooltipContentLogo: i18n.t('tooltip.logo_png'),
      header: {
        title: i18n.t('plantilla_pdf.header'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: this.isFromClient ? 'configurations/clients/details' : 'configurations/clients'
      },
      msgDefaultDisabledEditor: i18n.t('personalization.disabled_editor_default_msg'),
      customXsltVisor: true,
      form: {
        basetemplate: '',
        textoIzq: false,
        TraducirParaExtranjeros: false
      },
      maxSizefile: 1048576, // Bytes (1MB)
      fileLogo: {
        name: '',
        b64: '',
        bytes: null,
      },
      // Contenido para cada TextEditor
      contentTextEditorDefaultXsltVisor: '',
      // Etiquetas para cada TextEditor
      tagsCustomXsltVisor: [],
      rules: {
        basetemplate: [
          {
            required: true,
            message: i18n.t('validation.complete'),
            trigger: ['blur', 'change']
          },
        ],
        fileLogo: [
          {
            message: i18n.t('validation.not_single_valid_extension', { ext: '.png' }),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileLogo.name && (this.fileLogo.name.length < 3 || this.getExtensionFromFile(this.fileLogo.name).toUpperCase() !== 'PNG')) {
                callback(new Error(i18n.t('validation.not_single_valid_extension', { ext: '.png' })))
              } else {
                callback()
              }
            }
          },
          {
            message: i18n.t('validation.logo_width_height'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileLogo.name &&
                (this.$refs['logo-custom-client-light'].naturalHeight !== 74 || this.$refs['logo-custom-client-light'].naturalWidth !== 300)) {
                callback(new Error(i18n.t('validation.logo_width_height')))
              } else {
                callback()
              }
            }
          },
          {
            message: i18n.t('validation.exceed_size_files') + ' (1 MB)',
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.fileLogo.name && this.fileLogo.bytes && 
                this.fileLogo.bytes.size > this.maxSizeFile) {
                callback(new Error(i18n.t('validation.exceed_size_files')))
              } else {
                callback()
              }
            }
          },
        ],
      },


      showHtml: false,
      editTemplate: false,
      generatedHtml: '',
      lasttemplate: null,
      lastpdf: {
        name: '',
        url: ''
      },
      baseTemplates: [],
      exampleXml: '',
      defaultHtml: i18n.t('plantilla_pdf.xslt_not_valid'),
      actualFilterContent: null,
      haseditor: false,
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    fileLogo: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.textoIzq' (value) {
      if (this.showHtml) {
        if (value) {
          if (!this.form.basetemplate.PdfEjemploIzq || this.editTemplate) {
            this.generateHtmlFromXslt()
          }
        } else {
          if (!this.form.basetemplate.PdfEjemplo || this.editTemplate) {
            this.generateHtmlFromXslt()
          }
        }
      }
    },
    showHtml (newValue) {
      if (newValue) {
        this.lastpdf.name = this.form.basetemplate.Nombre
        this.lastpdf.url = this.b64Pdf ? `data:application/pdf;base64,${this.b64Pdf}` : ''
        if (this.form.textoIzq) {
          if (!this.form.basetemplate.PdfEjemploIzq || this.editTemplate) {
            this.generateHtmlFromXslt()
          }
        } else {
          if (!this.form.basetemplate.PdfEjemplo || this.editTemplate) {
            this.generateHtmlFromXslt()
          }
        }
      }
    },
    editTemplate (value) {
      if (value) {
        this.$nextTick(() => this.$set(this, 'haseditor', true))
        if (this.showHtml) {
          this.generateHtmlFromXslt()
        }
      } else {
        this.$set(this, 'haseditor', false)
      }
    },
    generatedHtml (value, oldValue) {
      // if (value !== oldValue) {
      this.insertIframeContent()
      // }
    }
  },
  computed: {
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id () {
      return this.$route.params.id ? this.$route.params.id : -1
    },
    isFromClient () {
      return this.id !== -1
    },
    hasModuleCustomXslt () {
      return this.$store.getters['auth/hasXsltModule']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    hasPdf: function () {
      return !this.editTemplate && !!((!this.form.textoIzq && this.form.basetemplate?.PdfEjemplo) || (this.form.textoIzq && this.form.basetemplate?.PdfEjemploIzq))
    },
    b64Pdf: function () {
      return this.form.textoIzq ? this.form.basetemplate?.PdfEjemploIzq : this.form.basetemplate?.PdfEjemplo
    },
    pdfUrl: function () {
      return (this.b64Pdf && this.showHtml ? `data:application/pdf;base64,${this.b64Pdf}` : this.lastpdf.url) || ''
    },
    pdfName: function () {
      return this.form.basetemplate?.Nombre || this.lastpdf.name || ''
    },
    hasLogoSaved () {
      return this.fileLogo && this.fileLogo.b64 && !this.fileLogo.bytes
    },
  },
  created: async function () {
    const breadcrumbs = []

    if (this.isFromClient) {
      breadcrumbs.push({
        path: this.role === 3 ? 'configurationssa' : 'configurations',
        name: i18n.t('configurations.header')
      })
      breadcrumbs.push({
        path: 'configurations/clients',
        name: i18n.t('clients.header')
      })
      if (this.$store.getters['app/fromRouteName'] !== null) {
        const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
        breadcrumbs.push({ path: '', name: breadcrumbHeader })
      } else {
        const cliente = await this.downloadClientData(this.id)
        breadcrumbs.push({ path: '', name: cliente.Nombre })
        this.$store.commit('app/setheaderBreadCrumb', cliente.Nombre)
      }
    }

    this.header.breadcrumb = breadcrumbs

    if (this.hasModuleCustomXslt) {
      this.$store.commit('setIsLoading', true)
      const dataXslt = await this.downloadDataXslt(this.isFromClient ? this.id : null)
      this.setDataXslt(dataXslt?.Respuesta)
      if (this.showHtml) {
        this.generateHtmlFromXslt()
      }
      this.$store.commit('setIsLoading', false)
    }
  },
  mounted () {
    this.isMounted = true
    this.header.url = this.isFromClient ? 'configurations/clients/details' : 'configurations'
    this.resetControlFormChanges()
  },
  methods: {
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
      if (this.form.basetemplate && this.showHtml) {
        this.lastpdf.name = this.form.basetemplate.Nombre
        this.lastpdf.url = this.b64Pdf ? `data:application/pdf;base64,${this.b64Pdf}` : ''
      }
    },
    handleChangeLogo: function (fileLogo) {
      this.$refs.uploadlogo.clearValidate()
      this.fileLogo.name = fileLogo.name
      this.getBase64(fileLogo.raw).then(res => {
        const b64 = res.split(',')
        this.fileLogo.b64 = b64[1]
      })
      this.fileLogo.bytes = fileLogo
    },
    handleRemoveLogo: function () {
      this.fileLogo.name = null
      this.fileLogo.b64 = null
      this.fileLogo.bytes = null
    },
    downloadClientData: async function (id) {
      let client = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idCliente: id
        }
        const response = await getClient(params)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        }
        client = response.Cliente
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return client
    },
    submitForm: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            idCliente: this.isFromClient ? this.id : null,
            idPlantilla: this.form.basetemplate.idPlantilla,
            TextoIzq: !!this.form.textoIzq,
            TraducirParaExtranjeros: !!this.form.TraducirParaExtranjeros,
            Logo: this.fileLogo && this.fileLogo.b64 && this.fileLogo.name
              ? {
                Contenido: this.fileLogo.b64,
                Extension: this.getExtensionFromFile(this.fileLogo.name)
              } 
              : null,
          }
          const response = await updatePlantillaXslt(params)
          if (response.blnError === true) {
            this.doFeedback(`${response.msgError} [${response.codError}]`)
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      if (this.role === 2) {
        this.$router.push({ name: 'configurations' })
      } else {
        if (this.isFromClient) this.$router.push({ name: 'configurations/clients/details', params: this.id })
        else this.$router.push({ name: 'configurations/clients' })
      }
    },
    downloadDataXslt: async function (id) {
      try {
        const template = await getPlantillasImagen({ idCliente: id })
        if (template.blnError === true) {
          this.doFeedback(`${template.msgError} [${template.codError}]`)
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      }
      return null
    },
    setDataXslt: function (data) {
      if (data) {
        this.baseTemplates = data.templates
        this.form.basetemplate = data.config?.PlantillaActiva || ''
        this.form.textoIzq = !!data.config?.TextoIzq
        this.form.TraducirParaExtranjeros = !!data.config?.TraducirParaExtranjeros
        this.fileLogo.b64 = data.Logo?.Contenido 
        this.fileLogo.name = data.Logo 
          ? 'custom-logo.' + data.Logo?.Extension 
          : null
        if (this.form.basetemplate) {
          this.showHtml = true
        }
      }
      this.resetControlFormChanges()
    },
    setDataXsltTags: function (data) {
      if (data) {
        // Tags
        this.tagsCustomXsltVisor = data.tags.filter(x => x.Nombre === 'CustomXsltVisor')[0].Tags
      }
      this.resetControlFormChanges()
    },
    selectBaseTemplate: function (template) {
      if (template) {
        // Contenido
        this.contentTextEditorDefaultXsltVisor = template.Contenido

        // Es editable a través del editor ?
        this.customXsltVisor = template.Owner
      } else {
        // Contenido
        this.contentTextEditorDefaultXsltVisor = ''

        // Es editable a través del editor ?
        this.customXsltVisor = false
      }
    },
    async generateHtmlFromXslt () {
      if (!this.hasPdf) {
        // const editortext = this.$refs.textEditorCustomXsltVisor?.getContent() ?? ''
        if (this.form.basetemplate && (/* this.editTemplate ? (this.lasttemplate?.Contenido !== editortext) : */ (this.lasttemplate?.Contenido !== this.form.basetemplate?.Contenido))) {
          this.lasttemplate = JSON.parse(JSON.stringify(this.form.basetemplate))
          var { /* valido, */ xslt } = this.validarYCorregirXSLT(/* this.editTemplate ? editortext : */ this.form.basetemplate.Contenido) /* Validar y corregir este string */
          // if (!valido) {
          //   const validation = this.validarYCorregirXSLT(xslt)
          //   if (!validation.valido) {
          //     this.transformedHtml = this.defaultHtml
          //     return
          //   }
          // }
          this.lasttemplate.Contenido = xslt
  
          const parser = new DOMParser()
          const xsltDoc = parser.parseFromString((xslt || ''), 'application/xml')
          if (!this.exampleXml) {
            const response = await genericGETFile('/api/personalizacion/getxmlejemplo')
            this.exampleXml = await response.data.text()
          }
          const xmlDoc = parser.parseFromString(this.exampleXml, 'application/xml')
  
          const xsltProcessor = new XSLTProcessor()
          xsltProcessor.importStylesheet(xsltDoc)
          let resultDoc = xsltProcessor.transformToDocument(xmlDoc)
  
          if (!resultDoc) {
            resultDoc = parser.parseFromString(this.defaultHtml, 'text/html')
          }
  
          const serializer = new XMLSerializer()
          let transformedHtml = serializer.serializeToString(resultDoc)
  
          transformedHtml = transformedHtml.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
          transformedHtml = transformedHtml.replace(/<script\b[^<]*\/>/gi, '')
          transformedHtml = transformedHtml.replace(/<[^>]*\bon[^=]*=[^>]*>/gi, '')
  
          this.generatedHtml = transformedHtml
        } else {
          this.$nextTick(() => this.insertIframeContent())
        }
      }
    },
    validarYCorregirXSLT (xslt) {
      try {
        const parser = new DOMParser()
        const xmlDoc = parser.parseFromString(xslt, 'application/xml')
        if (!xmlDoc || !xmlDoc.doctype || xmlDoc.doctype.name.toLowerCase() !== 'xsl:stylesheet') {
          return { valido: false, xslt } // No es un XSLT válido
        }
        // Si el documento es válido, retorna el HTML/XSLT sin cambios
        return { valido: true, xslt }
      } catch (error) {
        // Si ocurre un error al parsear, devuelve el HTML/XSLT sin cambios
        return { valido: false, xslt }
      }
    },
    closeUnClosedTags (xslt) {

    },
    insertIframeContent () {
      let iframe = document.getElementById('container-xhtml-iframe')

      if (iframe) {
        iframe = iframe.contentWindow || (iframe.contentDocument.document || iframe.contentDocument)
  
        iframe.document.open()
        iframe.document.write(this.generatedHtml)
        var style = iframe.document.createElement('style')

        // Agregar reglas de estilo al elemento de estilo
        style.innerHTML = '.page { padding: 15mm; }'

        // Agregar el elemento de estilo al encabezado del documento dentro del iframe
        if (!iframe.document.head) {
          const head = document.createElement('head')
          head.appendChild(style)
          iframe.document.appendChild(head)
        } else {
          iframe.document.head.appendChild(style) 
        }
        iframe.document.close()
      }
    },
    optionValue (option) {
      return option
    },
    onBaseTemplateInput (value) {
      if (this.showHtml) {
        if (this.form.textoIzq) {
          if (!this.form.basetemplate.PdfEjemploIzq || this.editTemplate) {
            this.generateHtmlFromXslt()
          }
        } else {
          if (!this.form.basetemplate.PdfEjemplo || this.editTemplate) {
            this.generateHtmlFromXslt()
          }
        }
      }
      this.selectBaseTemplate(value)
    },
    baseTemplateCreateMethod (value) {
      return {
        Nombre: value,
        Contenido: '',
        Owner: true,
      }
    },
    onBaseTemplateClear () {
      this.showHtml = false
      if (this.baseTemplates[0]?.Created) {
        this.baseTemplates.shift()
      }
    },
    toggleHtmlView () {
      if (this.showHtml) {
        this.generateHtmlFromXslt()
      }
    },
    applyChanges () {
      if (this.editTemplate) {

      }
      this.editTemplate = !this.editTemplate
    },
    cancelChanges () {
      this.$refs.textEditorCustomXsltVisor.xslt = ''
      this.editTemplate = false
    },
    pdfViewerOpenHandler () {
      this.actualFilterContent = null
    },
    filterByParamsData () {
      const data = this.$route.params.data
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'contenido') {
            this.actualFilterContent = filter.data
          }
        })
      }
    },
  }
}
</script>

<style scoped>
.transformed-result {
  background-color: var(--secondary-100) !important;
  border-bottom-left-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
  margin-top: 5px;
  margin-inline: auto;
  width: 100%;
  height: 100%;
  min-height: 297mm;
  max-height: 297mm;
  min-width: 210mm;
  max-width: 210mm;
  box-sizing: border-box;
}
@media (min-width: 1024px) {
  .layout-detail-two-columns.haspdf::v-deep > main {
    overflow-y: hidden;
  }
}

#pfxselector:has(.is-disabled)::v-deep * {
 cursor: not-allowed;
}

.hideHScroll {
  overflow-x: hidden;
}
</style>
